module.exports = __webpack_public_path__ + "static/media/ArrowDown.fe39b030.svg";